import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Abdul Mohammed",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.5/5",
    experience: "18 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Gallstones Specialist"
  },
  {
    name: "Dr. Prudhvinath",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Laparoscopic Surgeon"
  },
  {
    name: "Dr. Anuj Kumar Patel",
    qualification: "MBBS, MS-General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Gallbladder Expert"
  },
  {
    name: "Dr. Ravi Sharma",
    qualification: "MBBS, MS - Surgery",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "12 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Gallstones Treatment"
  },
  {
    name: "Dr. Meera Iyer",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "10 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Senior Surgeon"
  },
  {
    name: "Dr. Karthik Rao",
    qualification: "MBBS, MS - Surgery",
    fee: "FREE Consultation",
    rating: "4.5/5",
    experience: "16 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Gallbladder Surgery Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Gallstones Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Connect with top gallbladder specialists and book FREE consultations for advanced gallstones treatment.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Appointment
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const Gallstones = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Gallstones Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Revolutionary Keyhole Gallbladder Surgery with 99% Success Rate. Painless Procedure, Quick Recovery, Same Day Discharge.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              View Treatment Options
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>12,500+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Successful Surgeries</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>99%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>30 min</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>24 hrs</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Back to Normal Life</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "causes", label: "Causes", icon: "🎯" },
              { id: "types", label: "Types", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "recovery", label: "Recovery", icon: "🔄" },
              { id: "prevention", label: "Prevention", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Gallstones Treatment</span>
            </h2>
          </div>

          {/* What are Gallstones */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Gallstones
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Gallstones are hardened deposits of digestive fluid that form in the gallbladder, 
                a small pear-shaped organ located beneath the liver. These stones can range in size 
                from tiny sand-like particles to large golf ball-sized stones and can cause severe 
                pain and complications when they block the bile ducts.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Asymptomatic Gallstones</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      "Silent stones" that don't cause any symptoms. Found incidentally during 
                      other medical tests. Often don't require immediate treatment but need monitoring.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Symptomatic Gallstones</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Stones that cause biliary colic, inflammation, or complications. 
                      Characterized by severe abdominal pain, nausea, and require medical intervention.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Symptoms */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Symptoms Guide
            </h3>

            <div className="row">
              {[
                {
                  title: "Biliary Colic", 
                  description: "Sudden, intense pain in the upper right abdomen that may radiate to back or shoulder",
                  details: "Typically occurs after fatty meals and lasts 30 minutes to several hours"
                },
                {
                  title: "Nausea & Vomiting", 
                  description: "Persistent nausea and vomiting, especially after eating fatty foods",
                  details: "Due to gallbladder inflammation and bile duct obstruction"
                },
                {
                  title: "Fever & Chills", 
                  description: "High fever with chills indicating possible infection or inflammation",
                  details: "Emergency sign suggesting acute cholecystitis or infection"
                },
                {
                  title: "Jaundice", 
                  description: "Yellowing of skin and eyes, dark urine, and pale stools",
                  details: "Indicates bile duct obstruction by gallstones"
                },
                {
                  title: "Bloating & Indigestion", 
                  description: "Chronic indigestion, gas, bloating, and discomfort after meals",
                  details: "Common with multiple small gallstones"
                },
                {
                  title: "Clay-colored Stools", 
                  description: "Light-colored stools due to lack of bile reaching intestines",
                  details: "Sign of complete bile duct obstruction requiring immediate attention"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Types of Gallstones */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Gallstones
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Cholesterol Stones",
                    description: "Most common type (80%). Yellow-green stones composed mainly of undissolved cholesterol. Form when bile contains too much cholesterol or not enough bile salts.",
                    composition: "Primarily Cholesterol"
                  },
                  {
                    type: "Pigment Stones",
                    description: "Dark brown or black stones made of bilirubin. Form when bile contains excess bilirubin. More common in people with liver cirrhosis, biliary infections, or blood disorders.",
                    composition: "Bilirubin & Calcium"
                  },
                  {
                    type: "Mixed Stones",
                    description: "Combination of cholesterol, bilirubin, and calcium salts. Most common type found in patients. Vary in size and composition, often forming in layers.",
                    composition: "Mixed Composition"
                  },
                  {
                    type: "Calcium Stones",
                    description: "Rare stones composed mainly of calcium with other minerals. Often associated with specific metabolic conditions or prolonged fasting states.",
                    composition: "Calcium Salts"
                  }
                ].map((stoneType, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {stoneType.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {stoneType.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {stoneType.composition}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Too much cholesterol in bile leading to crystal formation</li>
                      <li style={{ marginBottom: "10px" }}>Gallbladder not emptying properly or completely</li>
                      <li style={{ marginBottom: "10px" }}>Excess bilirubin in bile due to liver conditions</li>
                      <li style={{ marginBottom: "10px" }}>Concentrated bile from fasting or rapid weight loss</li>
                      <li>Genetic predisposition and family history of gallstones</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Female gender (2-3 times more common in women)</li>
                      <li style={{ marginBottom: "10px" }}>Age over 40 years</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and rapid weight loss</li>
                      <li style={{ marginBottom: "10px" }}>Pregnancy and hormone replacement therapy</li>
                      <li>Diabetes, liver disease, and certain blood disorders</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Advanced Treatment Options
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Laparoscopic Cholecystectomy
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Gold standard treatment for symptomatic gallstones. Minimally invasive keyhole surgery 
                    to remove the gallbladder through 3-4 small incisions. This procedure offers rapid recovery, 
                    minimal pain, and excellent cosmetic results while permanently solving gallstone problems.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Key Benefits:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>3-4 small incisions, minimal scarring</li>
                          <li style={{ marginBottom: "8px" }}>Significantly less post-operative pain</li>
                          <li style={{ marginBottom: "8px" }}>30-45 minute procedure</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Same day or next day discharge</li>
                          <li style={{ marginBottom: "8px" }}>99% success rate</li>
                          <li style={{ marginBottom: "8px" }}>Rapid return to normal activities</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Comprehensive Treatment Approaches
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Single Incision Laparoscopic Surgery (SILS):</strong> Single hidden incision through belly button</li>
                      <li style={{ marginBottom: "10px" }}><strong>Robotic Cholecystectomy:</strong> Enhanced precision using robotic surgical system</li>
                      <li style={{ marginBottom: "10px" }}><strong>Open Cholecystectomy:</strong> Traditional approach for complex cases</li>
                      <li style={{ marginBottom: "10px" }}><strong>ERCP with Sphincterotomy:</strong> For bile duct stones combined with gallbladder removal</li>
                      <li><strong>Percutaneous Cholecystostomy:</strong> Temporary drainage for high-risk patients</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Non-Surgical Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Oral dissolution therapy (ursodeoxycholic acid)</li>
                      <li style={{ marginBottom: "10px" }}>Extracorporeal shock wave lithotripsy (ESWL)</li>
                      <li>Contact dissolution therapy (MTBE injection)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recovery Process */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Recovery Timeline After Surgery
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-2",
                    title: "Immediate Recovery",
                    activities: ["Same day or 24-hour discharge", "Mild pain managed with medication", "Liquid to soft diet", "Light walking encouraged"]
                  },
                  {
                    period: "Week 1",
                    title: "Early Healing",
                    activities: ["Return to desk work in 3-5 days", "Gradual return to normal diet", "Wound care", "Avoid heavy lifting"]
                  },
                  {
                    period: "Week 2-3",
                    title: "Active Recovery",
                    activities: ["Resume most normal activities", "Light exercise and driving", "Normal diet tolerance", "Follow-up appointment"]
                  },
                  {
                    period: "Month 1+",
                    title: "Full Recovery",
                    activities: ["Return to all activities including sports", "No dietary restrictions for most", "Complete healing", "Final surgical review"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention Section */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Lifestyle Management
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Dietary Prevention</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maintain healthy weight through balanced diet and exercise</li>
                      <li style={{ marginBottom: "10px" }}>Avoid rapid weight loss and crash diets</li>
                      <li style={{ marginBottom: "10px" }}>Eat high-fiber foods (fruits, vegetables, whole grains)</li>
                      <li>Limit saturated fats and choose healthy fats in moderation</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Healthy Habits</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Eat regular meals without skipping breakfast</li>
                      <li style={{ marginBottom: "10px" }}>Stay hydrated with plenty of water</li>
                      <li style={{ marginBottom: "10px" }}>Exercise regularly to maintain healthy weight</li>
                      <li>Limit alcohol consumption and avoid smoking</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Can I live normally without a gallbladder?",
                  answer: "Yes, absolutely. The gallbladder is a storage organ, not essential for digestion. After removal, bile flows directly from the liver to the intestine. Most people live completely normal lives without any dietary restrictions after full recovery. Some may experience temporary changes in bowel habits that usually resolve within a few weeks."
                },
                {
                  question: "What is the success rate of laparoscopic gallbladder surgery?",
                  answer: "Laparoscopic cholecystectomy has a success rate of 98-99% with very low complication rates. It's considered one of the safest and most effective surgical procedures. The risk of stone recurrence is virtually zero since the gallbladder, where stones form, is removed."
                },
                {
                  question: "How soon can I return to work after gallbladder surgery?",
                  answer: "For desk jobs, most patients return within 3-5 days. For physically demanding jobs, 1-2 weeks may be needed. Your surgeon will provide specific recommendations based on your recovery progress and job requirements. Most normal activities can be resumed within a week."
                },
                {
                  question: "Are there any dietary restrictions after gallbladder removal?",
                  answer: "Most people can return to their normal diet within a few weeks. Initially, you may be advised to avoid very fatty or greasy foods as your body adjusts to continuous bile flow. Over time, most patients can eat normally without restrictions. Some may benefit from smaller, more frequent meals initially."
                },
                {
                  question: "What are the risks of not treating symptomatic gallstones?",
                  answer: "Untreated symptomatic gallstones can lead to serious complications including acute cholecystitis (gallbladder inflammation), pancreatitis, cholangitis (bile duct infection), gallbladder perforation, or gangrene. These conditions are medical emergencies that require immediate treatment and can be life-threatening."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to End Gallstone Pain Forever?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Don't let gallstones control your life. Book your FREE consultation with our expert surgeons today!
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Gallstones;